import React from "react";
import FeatureCarousel from "../Slider/FeatureCarousel";
import SectionHeading from "../SectionHeading";
import Spacing from "../Spacing";

export default function FeaturesSectionStyle4({
  sectionTitleUp,
  sectionTitle,
  data,
}) {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-8 offset-lg-4">
          <SectionHeading title={ sectionTitle } titleUp={ sectionTitleUp } />
        </div>
      </div>
      <Spacing md="72" lg="50" />
      <FeatureCarousel data={ data } />
    </div>
  );
}
